import React, { useContext, useState } from "react";
import _ from "lodash";
import InscricaoEntity from "entity/Inscricao";

import Reuniao from "entity/Reuniao";

export const PainelContext = React.createContext({});

export const PainelProvider = ({ children }) => {
    const [inscricoes, setInscricoes] = useState([]);
    const [reunioes, setReunioes] = useState([]);

    const startListnersRodada = (rodada) => {
        let observerInscricao = null;
        let observerReuniao = null;

        if (rodada?.uid) {
            let novasMesas = rodada.mesas || [];
            let novasMesasUid = novasMesas.map((m) => m.uid);
            const updateMesaInsc = (insc) => {
                if (insc.mesa) {
                    let index = novasMesasUid.indexOf(insc.mesa.uid);
                    insc.mesa = novasMesas[index];
                }
            };
            const updateMesaReun = (reu) => {
                if (reu.mesa) {
                    let index = novasMesasUid.indexOf(reu.mesa.uid);
                    reu.mesa = novasMesas[index];
                }
                delete reu.dataLastChangeServer;
            };
            observerInscricao = InscricaoEntity.collection.where("rodada.uid", "==", rodada.uid).onSnapshot((snap) => {
                setInscricoes((prevInscriptions) => {
                    let retorno = prevInscriptions ? [...prevInscriptions] : [];
                    snap.docChanges().forEach((change) => {
                        // console.log("Inscriptions change.type", change.type);
                        if (change.type === "added") {
                            const insc = change.doc.data();
                            updateMesaInsc(insc);
                            retorno.push(insc);
                        } else if (change.type === "modified") {
                            const updatedInscription = change.doc.data();
                            updateMesaInsc(updatedInscription);

                            const index = retorno.findIndex(
                                (inscription) => inscription.uid === updatedInscription.uid
                            );

                            retorno[index] = updatedInscription;
                        } else {
                            console.log("setInscricoes change.type", change.type);
                        }
                    });

                    return retorno;
                });
            });
            observerReuniao = Reuniao.collection
                .where("rodada.uid", "==", rodada.uid)
                .where("status", "==", "ATIVO")
                .onSnapshot((snap) => {
                    setReunioes((prevReunioes) => {
                        let retorno = prevReunioes ? [...prevReunioes] : [];
                        snap.docChanges().forEach((change) => {
                            const reuniaoData = change.doc.data();
                            if (change.type === "added") {
                                updateMesaReun(reuniaoData);
                                retorno.push(reuniaoData);
                            } else if (change.type === "modified") {
                                updateMesaReun(reuniaoData);
                                const index = retorno.findIndex((r) => r.uid === reuniaoData.uid);
                                if (!_.isEqual(retorno[index], reuniaoData)) {
                                    retorno[index] = reuniaoData;
                                }
                            } else if (change.type === "removed") {
                                console.log("remove ", reuniaoData);
                                const index = retorno.findIndex((r) => r.uid === reuniaoData.uid);
                                if (index > -1) {
                                    retorno.splice(index, 1);
                                }
                            } else {
                                console.log("setReunioes change.type", change.type, change.doc.data());
                            }
                        });

                        retorno.sort((a, b) => {
                            let aH = (a.horariotxt || "").split("-").reverse().join("");
                            let bH = (b.horariotxt || "").split("-").reverse().join("");
                            return aH > bH ? 1 : -1;
                        });
                        return retorno;
                    });
                });
        }
        return [observerInscricao, observerReuniao];
    };

    return (
        <PainelContext.Provider value={{ startListnersRodada, inscricoes, reunioes }}>
            {children}
        </PainelContext.Provider>
    );
};
export const usePainelContext = () => useContext(PainelContext);
